import { dynamicAssets, staticImageAssets } from 'js/constants/Paths';
import { parseSrcSetImages } from 'js/utils/general';

export const parseWatchData = (data) => {
  const { header = {}, ctas = false } = data;
  const { video: headerVideo = '', video_poster: headerVideoPoster = '' } = header;

  headerVideo !== '' && (header.video = dynamicAssets(header.video));
  headerVideoPoster !== '' && (header.video_poster = dynamicAssets(headerVideoPoster));
  console.log('ctas', ctas);
  if (ctas && ctas?.content?.length && ctas?.content?.length > 0) {
    ctas.content.forEach((cta) => {
      const { image = '' } = cta;
      image !== '' && (cta.image = dynamicAssets(image));
    });
  }

  return { ...data };
};
